const dev = "flexibees.appinessworld.com:80";
const stage = "stagflexapi.appiness.co.in";

const BaseURL = `https://${stage}/api/admin`;
const SocketURL = `ws://${stage}/ws`;

export const API = {
  LOGIN: `${BaseURL}/login/`,
  CHANGE_PASSWORD: `${BaseURL}/change-password/`,
  FORGOT_PASSWORD: `${BaseURL}/forgot-password/`,
  MEDIA_UPLOAD: `${BaseURL}/media-upload/`,
  VIEW_PROFILE: `${BaseURL}/view-profile/`,
  EDIT_PROFILE: `${BaseURL}/edit-profile/`,
  TAB_COUNT: `${BaseURL}/all-project-count/`,
  FROM_CRM: `${BaseURL}/from-crm`,
  PULL_FROM_CRM: `${BaseURL}/pull-from-crm/`,
  GET_PROFILETABLE: `${BaseURL}/profile-table`,
  GET_PROFILETABLE_VIEW_PRICING: `${BaseURL}/view-pricing`,
  UPDATE_PRICING_TO_CLIENT: `${BaseURL}/add-pricing/`,
  SEND_TO_PROFILE_TABLE: `${BaseURL}/send-to-profile`,
  GET_ADMIN_ROLES: `${BaseURL}/role/`,
  GET_RECRUITMENT: `${BaseURL}/recruitment`,
  GET_RECRUITMENT_PRICING_HISTORY: `${BaseURL}/view-pricing`,
  PROJECT: `${BaseURL}/project`,
  GET_ADMIN_SKILLS: `${BaseURL}/skill/`,
  GET_ADMIN_DOMAINS: `${BaseURL}/domain/`,
  GET_DYNAMIC_DROPDOWN_FROM_CONFIG: `${BaseURL}/dropdown-values/`,
  GET_LANGUAGES: `${BaseURL}/language/`,
  GET_FINAL: `${BaseURL}/final-selection`,
  CLOSE_PROJECT: `${BaseURL}/close-project`,
  GET_SUSPENDED: `${BaseURL}/suspended`,
  GET_CLOSED: `${BaseURL}/closed`,
  UPDATE_LAUNCH_DATE: `${BaseURL}/update-launch-date`,
  VIEW_CLOSED_REASON: `${BaseURL}/view-closed-reason`,
  VIEW_PROJECT: `${BaseURL}/view-project`,
  VIEW_SUSPEND_REASON: `${BaseURL}/view-suspended-reason`,
  VIEW_PROJECT_INFO: `${BaseURL}/project-info`,
  UPDATE_ASSIGNMENT: `${BaseURL}/assignment-upload`,
  GET_NOTIFICATION: `${BaseURL}/notification`,
  NOTIFICATION_COUNT: `${SocketURL}/admin-notification`,
  FINAL_SELECTION_LIST: `${BaseURL}/final-candidates`,
  UPDATE_CLIENT_FEEDBACK: `${BaseURL}/update-client-feedback`,
  VIEW_CLIENT_FEEDBACK: `${BaseURL}/view-client-feedback`,
  GET_CANDIDATE_DETAILS: `${BaseURL}/candidate-detail`,
  DOWNLOAD_FLEXIBEES_RESUME: `${BaseURL}/candidate-resume-download`,
  CANDIDATE_JOURNEY: `${BaseURL}/candidate-journey`,
  CANDIDATE_JOURNEY_FEEDBACK: `${BaseURL}/candidate-feedback-list`,
  // prject launches

  PROJECT_LAUNCH_LIST: `${BaseURL}/project/launch/list`,
  EDIT_PROJECT_NOTES: `${BaseURL}/project/launch/update`,
  PROJECT_LAUNCH_DETAILS: `${BaseURL}/project-launch/details`,
  PROJECT_RENEWALS_LIST: `${BaseURL}/project-renewals/list/`,
};
